export const SET_MARKETS = 'SET_MARKETS';
